import { render } from "./AddInstitution.vue?vue&type=template&id=e0cda480&lang=pug"
import script from "./AddInstitution.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInstitution.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__